/**
 * Created by Languagenut on 17/09/2019.
 */


import React  from 'react';
import Translation from  '../../store/internationalization-store.js';
import {ProgressBar , Row , Tabs , Tab, Col } from 'react-bootstrap'
import GeneralTable from '../general_table.js';
import ClassesService from '../../services/classes-service.js';
import ProductService from '../../services/product-service.js';
import AccountService from '../../services/account-service.js';
import ClassesStore from '../../store/classes-store.js'
import Constants from '../../constants.js';
import LanguageSelect from '../language_select.js'
Date.prototype.getUnixTime = function() { return this.getTime()/1000|0 };

export default class Overview extends React.Component {
    
    constructor(props) {
        super();
        this.vocabBreadCrumb = [{name:"Vocabulary", screenUid:100}];
        this.grammarBreadCrumb = [{name:"Grammar", screenUid:14100}];
        this.sentenceBreadCrumb = [{name:"Sentence", screenUid:100}];
        this.examBreadCrumb = [{name:"Exam", screenUid:12050}];
        this.verbBreadCrumb = [{name:"Verb"}];
        var d =   new Date();
        var due = new Date(); due.setMonth(due.getMonth() - 12);
        let to  =  d.getUnixTime();
        let from  = due.getUnixTime();

        this.props = props;
        this.vocabScreen = undefined;
        this.examScreen = undefined;
        this.grammarScreen = undefined;
        this.sentenceScreen = undefined;
        this.isVerbs = false;
        this.additionalDataScreens = [];
        
        this.state = {
            from:from,
            to:to,
            loaded:false,
            features:[],
            key:"vocab",
            keys:{},
            number:14,
            grammarProgressTable:[],
            verbProgressTable:[],
            summary:{}
        };
    }

    componentWillReceiveProps(props){
        this.props = props;
        this.setState({
            "update":true
        });
    }

    formatVerbData(temp) {
        var end = [];
        var counter = 0;
        for (var i =0; i < temp.length; i++) {
            temp[i].id = counter;
            temp[i].type = "verb";
            if (temp[i].completedAll == undefined) {
                temp[i].completedAll = temp[i].completed;
            }
            temp[i].completedend = 0;
            if (temp[i].totalCompletable != 0 && temp[i].completedAll != 0) {
                temp[i].completedend = Math.round(temp[i].completedAll / (temp[i].totalCompletable / 100));
            }
            temp[i].completed = temp[i].completedend;
            temp[i].scores = {average: 0};
            if (temp[i].correct != 0 && temp[i].correct != null  && temp[i].correct != undefined
                    && temp[i].total != 0 && temp[i].total != null  && temp[i].total != undefined) {
                    temp[i].scores = {average:temp[i].correct / temp[i].total * 100};
            }
            //var title = Translation.getModuleNoIndexTranslation(temp[i].title);
            //temp[i].title = title;
            end.push(temp[i]);
            counter++;
        }
        return end;
    }

    componentDidMount() {
        ClassesStore.on(Constants.GET_CLASS_STUDENT_VOCABULARY_COMPLETED , ()=> {
            var temp = ClassesStore.vocabularyProgressTableStudent;
            if (temp != undefined) {
                for (var i =0; i < temp.length; i++) {
                    temp[i].id = i;
                    temp[i].type = "vocab";
                }
            }
            this.setState({
                vocabularyProgressTable:temp
            })
        });

        ClassesStore.on(Constants.GET_CLASS_STUDENT_MYCONTENT_COMPLETED , ()=> {
            var temp = ClassesStore.myContentProgressTableStudent;
            if (temp != undefined) {
                for (var i =0; i < temp.length; i++) {
                    temp[i].id = i;
                    temp[i].type = "vocab";
                }
            }
            if (temp.length == 0) {
                this.setState({
                    myContentProgressTable:undefined
                })   
            } else {
                this.setState({
                    myContentProgressTable:temp
                })
            }
            this.updateLanguage(this.language, true);
        });

        ClassesStore.on(Constants.GET_CLASS_STUDENT_VERB_COMPLETED , ()=> {
            var temp = ClassesStore.verbProgressTableStudent;
            if (temp != undefined) {
                for (var i =0; i < temp.length; i++) {
                    temp[i].id = i;
                    temp[i].type = "vocab";
                }
            }
            this.setState({
                verbProgressTable:temp
            })
        });

        ClassesStore.on(Constants.GET_CLASS_STUDENT_GRAMMAR_COMPLETED , ()=> {
            var temp = ClassesStore.grammarProgressTableStudent;
            if (temp != undefined) {
                for (var i =0; i < temp.length; i++) {
                    temp[i].id = i;
                    temp[i].type = "vocab";
                }
            }
            this.setState({
                grammarProgressTable:temp
            })
        });

        ClassesStore.on(Constants.GET_CLASS_STUDENT_SENTENCE_COMPLETED , ()=> {
            var temp = ClassesStore.sentenceProgressTableStudent;
            if (temp != undefined) {
                for (var i =0; i < temp.length; i++) {
                    temp[i].id = i;
                    temp[i].type = "vocab";
                }
            }
            this.setState({
                sentenceProgressTable:temp
            })
        });

        ClassesStore.on(Constants.GET_CLASS_STUDENT_EXAM_COMPLETED , ()=> {
            var temp = ClassesStore.examProgressTableStudent;
            if (temp != undefined) {
                for (var i =0; i < temp.length; i++) {
                    temp[i].id = i;
                    temp[i].type = "vocab";
                }
            }
            this.setState({
                examProgressTable:temp
            })
        });

        ProductService.getAllAdditionalCurriculums().then(function(data) {
            this.additionalData = data || [];
            this.updateStuff();
        }.bind(this));

        
        ProductService.getAllLanguages();
    }

    updateStuff() {
        if (this.packageUid == undefined) {
            return;
        }
        if (this.vocabScreen != undefined  && this.vocabScreen != null) {
            ClassesService.getVocabularyCompletedStudents(this.props.classUID, this.props.studentUid, this.curriculumUid, 
                this.languageUid);
            ClassesService.getMyContentCompletedStudents(this.props.classUID, this.props.studentUid, this.curriculumUid, 
                this.languageUid);
        }
        if (this.vocabScreen != undefined  && this.vocabScreen != null) {
            ClassesService.getVocabularyCompletedStudents(this.props.classUID, this.props.studentUid, this.curriculumUid, 
                this.languageUid);
        }
        if (this.examScreen != undefined  && this.examScreen != null) {
            ClassesService.getExamCompletedStudents(this.props.classUID, this.props.studentUid, this.curriculumUid, 
                this.languageUid, this.examScreen);
        }
        if (this.grammarScreen != undefined && this.grammarScreen != null) {
            ClassesService.getGrammarCompletedStudents(this.props.classUID, this.props.studentUid, this.packageUid, 
                this.languageUid, this.grammarScreen);
        }
        if (this.sentenceScreen != undefined  && this.sentenceScreen != null) {
            ClassesService.getSentenceCompletedStudents(this.props.classUID, this.props.studentUid, this.packageUid, 
                this.languageUid, this.sentenceScreen);
        }
        if (this.isVerbs == true) {
            ClassesService.getVerbCompletedStudents(
                this.props.classUID, this.props.studentUid, this.curriculumUid, this.languageUid);
        }

        for(var i = 0; i < this.additionalDataScreens.length; i++) {
            this.getVocabAdditional(i);
        }      
    }

    getVocabAdditional(index) {
        ClassesService.getVocabularyCompletedStudents(this.props.classUID, this.props.studentUid, this.additionalDataScreens[index].curriculumUid, 
            this.languageUid, true).then(function(data) {
                var temp = data;
                if (temp != undefined) {
                    for (var i =0; i < temp.length; i++) {
                        temp[i].id = i;
                        temp[i].type = "vocab";
                    }
                }
                if (this.additionalDataScreens[index] == undefined) {
                    return;
                }
                this.additionalDataScreens[index].table = temp
                this.setState({
                    update:true
                })
        }.bind(this));
    }

    percentage(cell){
        return <span><center>{(Math.round(cell * 10) / 10).toFixed(1) + '%'}</center></span>
    }

    averageScore(row){

        return <center>
            {row.text}<br/>
            <small>{Translation.get(12260)}</small>
        </center>
    }

    renderGradeCol(percentage){
        return <div>
            <b>{percentage}%</b><br/>
        </div>;

    }

    link(cell, row, id){

        return <a className="hyperlink" onClick={function(){

            if (row.type == "vocab") {
                var screenUid = this.state.vocabularyProgressTable[row.id].screenUid;
                if (screenUid != undefined && screenUid != "") {
                    this.vocabBreadCrumb.push({name:row.title, screenUid:screenUid})
                    ClassesService.getVocabularyCompleted(this.props.classUID, this.props.studentUid, 5, 
                        this.languageUid , screenUid);
                }
                
            } else if (row.type == "grammar") {
                var screenUid = this.state.grammarProgressTable[row.id].screenUid;
                if (screenUid != undefined && screenUid != "") {
                    this.grammarBreadCrumb.push({name:row.title, screenUid:screenUid})
                    this.setState({
                        grammarBreadCrumb:[],
                    });
                    ClassesService.getGrammerComplete(this.props.classUID, this.props.studentUid, 5, 
                        this.languageUid , screenUid);
                }
                
            } else if (row.type == "sentence") {
                var screenUid = this.state.sentenceProgressTable[row.id].screenUid;
                if (screenUid != undefined && screenUid != "") {
                    this.sentenceBreadCrumb.push({name:row.title, screenUid:screenUid})
                    this.setState({
                        sentenceBreadCrumb:[],
                    });
                    ClassesService.getSentenceComplete(this.props.classUID, this.props.studentUid, 5, 
                        this.languageUid , screenUid);
                }
            } else if (row.type == "verb") {
                var verbUid = this.state.verbProgressTable[row.id].verbUid;
                if (this.state.verbProgressTable[row.id].subModules != undefined) {
                    var newData = this.formatVerbData(this.state.verbProgressTable[row.id].subModules);
                    this.verbBreadCrumb.push({name:row.title, data: newData})
                    this.setState({
                        verbProgressTable:this.formatVerbData(newData)
                    });
                }
            } else if (row.type == "exam") {
                var screenUid = this.state.examProgressTable[row.id].screenUid;
                var examUid = this.state.examProgressTable[row.id].examUid;
                if (screenUid != undefined && screenUid != "") {
                    this.examBreadCrumb.push({name:row.title, screenUid:screenUid})
                    this.setState({
                        examBreadCrumb:[],
                    });
                    ClassesService.getExamComplete(this.props.classUID, this.props.studentUid, 5, 
                        this.languageUid , screenUid);
                } else if (examUid != undefined && examUid != "") {
                    this.examBreadCrumb.push({name:row.title, screenUid:screenUid})
                    this.setState({
                        examBreadCrumb:[],
                    });
                    ClassesService.getExamQuestion(this.props.classUID, this.props.studentUid, 5, 
                        this.languageUid , examUid);
                }
            }
        }.bind(this)}>{cell}</a>
    }

    getCrumb(i, type) {
        if (type == "vocab") {
            return <a onClick={function(){
                    this.goToBreadCrumb(type, i)
                }.bind(this)}>{this.vocabBreadCrumb[i].name}</a>
        } else if (type == "sentence") {
            return <a onClick={function(){
                this.goToBreadCrumb(type, i)
            }.bind(this)}>{this.sentenceBreadCrumb[i].name}</a>
        } else if (type == "verb") {
            return <a onClick={function(){
                this.goToBreadCrumb(type, i)
            }.bind(this)}>{this.verbBreadCrumb[i].name}</a>
        } else if (type == "grammar") {
            return <a onClick={function(){
                this.goToBreadCrumb(type, i)
            }.bind(this)}>{this.grammarBreadCrumb[i].name}</a>
        } else if (type == "exam") {
            return <a onClick={function(){
                this.goToBreadCrumb(type, i)
            }.bind(this)}>{this.examBreadCrumb[i].name}</a>
        }
    }

    getBreadCrumb(type) {
        if (type == "vocab") {
            var totalEnd = [];
            for (var i =0; i < this.vocabBreadCrumb.length; i++) {
                if (i != 0) {
                    totalEnd.push(<span> / </span>)
                }
                var s = i;
                totalEnd.push(this.getCrumb(i, type));                    
            }
            return <div>{totalEnd}</div>;
        } else if (type == "sentence") {
            var totalEnd = [];
            for (var i =0; i < this.sentenceBreadCrumb.length; i++) {
                if (i != 0) {
                    totalEnd.push(<span> / </span>)
                }
                var s = i;
                totalEnd.push(this.getCrumb(i, type));                    
            }
            return <div>{totalEnd}</div>;
        } else if (type == "grammar") {
            var totalEnd = [];
            for (var i =0; i < this.grammarBreadCrumb.length; i++) {
                if (i != 0) {
                    totalEnd.push(<span> / </span>)
                }
                var s = i;
                totalEnd.push(this.getCrumb(i, type));                    
            }
            return <div>{totalEnd}</div>;
        } else if (type == "verb") {
            var totalEnd = [];
            for (var i =0; i < this.verbBreadCrumb.length; i++) {
                if (i != 0) {
                    totalEnd.push(<span> / </span>)
                }
                var s = i;
                totalEnd.push(this.getCrumb(i, type));                    
            }
            return <div>{totalEnd}</div>;
        }else if (type == "exam") {
            var totalEnd = [];
            for (var i =0; i < this.examBreadCrumb.length; i++) {
                if (i != 0) {
                    totalEnd.push(<span> / </span>)
                }
                var s = i;
                totalEnd.push(this.getCrumb(i, type));                    
            }
            return <div>{totalEnd}</div>;
        }
    }

    goToBreadCrumb(type, i) {
        if (type == "vocab") {
            this.setState({
                vocabularyProgressTable:[],
            });
            ClassesService.getVocabularyCompleted(this.props.classUID, this.props.studentUid, 5, 
                this.languageUid , this.vocabBreadCrumb[i].screenUid);
            this.vocabBreadCrumb = this.vocabBreadCrumb.slice(0,i+1);
        } else if (type == "sentence") {
            this.setState({
                sentenceBreadCrumb:[],
            });
            ClassesService.getSentenceComplete(this.props.classUID, this.props.studentUid, 5, 
                this.languageUid , this.sentenceBreadCrumb[i].screenUid);
            this.sentenceBreadCrumb = this.sentenceBreadCrumb.slice(0,i+1);
        } else if (type == "grammar") {
            this.setState({
                grammarBreadCrumb:[],
            });
            ClassesService.getGrammerComplete(this.props.classUID, this.props.studentUid, 5, 
                this.languageUid , this.grammarBreadCrumb[i].screenUid);
            this.grammarBreadCrumb = this.grammarBreadCrumb.slice(0,i+1);
        } else if (type == "verb") {
            this.verbBreadCrumb = this.verbBreadCrumb.slice(0,i+1);
            this.setState({
                verbProgressTable:this.verbBreadCrumb[i].data,
            });
        } else if (type == "exam") {
            this.setState({
                examBreadCrumb:[],
            });
            ClassesService.getExamComplete(this.props.classUID, this.props.studentUid, 5, 
                this.languageUid , this.examBreadCrumb[i].screenUid);
            this.examBreadCrumb = this.examBreadCrumb.slice(0,i+1);
        }
    }

    updateLanguage(language, skipClear) {
        if (language == undefined) {
            return;
        }
        var keys = {};
        var features = [];
        var isExam = false;
        var isVocab = false;
        var isContent = false;
        var isSentence = false;
        var isGrammar = false;
        var isVerb = false;
        this.language = language;
        this.languageUid = language.ietf;
        this.packageUid = language.packageUid;
        this.curriculumUid = language.curriculumUid;
        if (skipClear != true) {
            this.state.features = [];
            this.additionalDataScreens = [];
        }
        AccountService.getProductDetails(language.packageUid).then(function(data) {
            var productData = data;
            AccountService.getCurriculumDetails(language.curriculumUid).then(function(data) {
                var curriculumData = data;
                for (var i = 0; i < productData.length; i++) {
                    var featureUid = productData[i].features_uid;
                    switch (featureUid) {
                        case "exam":
                            if (curriculumData.examScreen != undefined) {
                                this.examScreen = curriculumData.examScreen;
                                isExam = true;
                                keys['exam'] = {
                                    title: Translation.get(12042 , 'Exam Skills'),
                                    general:"exam",
                                    table:"examProgressTable",
                                    is_skills:true,
                                }
                            }
                            break;
                        case "vocabs":
                            if (curriculumData.startScreen != undefined) {
                                this.vocabScreen = curriculumData.startScreen;
                                isVocab = true;
                                if ([9201, 9202, 9203, 20634,20669,20704].indexOf(parseInt(curriculumData.startScreen)) > -1) {
                                    keys['vocab'] = {
                                        title:"Cambridge IGCSE",
                                        general:"vocabulary",
                                        table:"vocabularyProgressTable",
                                        is_skills:true,
                                    }
                                } else if ([13300,13301,13302].indexOf(parseInt(curriculumData.startScreen)) > -1) {
                                    keys['vocab'] = {
                                        title:"Edexcel-International GCSE Vocabulary",
                                        general:"vocabulary",
                                        table:"vocabularyProgressTable",
                                        is_skills:true,
                                    }
                                } else {
                                    keys['vocab'] = {
                                        title:Translation.get(12233 , 'Vocabulary'),
                                        general:"vocabulary",
                                        table:"vocabularyProgressTable",
                                        is_skills:true,
                                    }
                                }
                            }
                            break;
                        case "sentences":
                            if (curriculumData.sentenceScreen != undefined) {
                                this.sentenceScreen = curriculumData.sentenceScreen;
                                isSentence = true;
                                keys['sentence'] = {
                                    title:Translation.get(89 , 'Sentence Building'),
                                    general:"grammar",
                                    table:"sentenceProgressTable",
                                    is_skills:false,
                                };
                            }
                        break;
                        case "custom":
                            if (this.state.myContentProgressTable != undefined) {
                                isContent = true;
                                keys['custom'] = {
                                    title:Translation.get(649 , 'My Content'),
                                    general:"grammar",
                                    table:"myContentProgressTable",
                                    is_skills:false,
                                };
                            }
                        break;
                        case "grammar":
                            if (curriculumData.grammarScreen != undefined) {
                                this.grammarScreen = curriculumData.grammarScreen;
                                isGrammar = true;
                                keys['grammar'] = {
                                    title:Translation.get(100 , 'Grammar'),
                                    general:"grammar",
                                    table:"grammarProgressTable",
                                    is_skills:false,
                                }
                            }
                        break;
                        case "verbs":
                            if (curriculumData.verbLanguages.includes(this.languageUid)) {
                                isVerb = true;
                                this.isVerbs = true;
                                keys['verb'] = {
                                    title:Translation.get(1028 , 'Verb'),
                                    general:"verb",
                                    table:"verbProgressTable",
                                    is_skills:false,
                                }
                            }
                        break;
                    }
                }

            
            
            
            if (isVocab) {
                features.push('vocab');
            }
            if (isContent) {
                features.push('custom');
            }
            if (isExam) {
                features.push('exam');
            }
            if (isSentence) {
                features.push('sentence');
            }
            if (isGrammar) {
                features.push('grammar');
            }
            if (isVerb) {
                features.push('verb');
            }

                if(!this.additionalData)
                {
                    this.additionalData = [];
                }

            for (var i = 0; i < this.additionalData.length; i++) {
                if (this.additionalData[i].isSelected == "1" && this.additionalData[i].ietf == this.languageUid) {
                    features.push('vocabAdditional-'+this.additionalDataScreens.length);
                    this.additionalDataScreens.push(this.additionalData[i]);
                }
            }
            if (skipClear != true) {
                this.updateStuff();
            }
            this.setState({features:features, keys:keys});
            }.bind(this));
        }.bind(this));
    }

    generateTabs(){

        let tabs = [];

        let columns = [
            {
                dataField: 'name',
                text: Translation.get(827 , 'Student Name'),
                headerStyle: (colum, colIndex) => {
                    return { width:'20%' };
                },
                getRowMetaData: (row) => row
            },
            {
                dataField: 'completed',
                text: Translation.get(12691 , 'Completed %'),
                headerStyle: (colum, colIndex) => {
                    return { width:'40%' };
                },
                formatter:(cell)=>{
                    var v =  Number((Math.ceil(cell ))).toFixed(0) + '%'
                    var x = Number((Math.ceil(cell ))).toFixed(0);
                    return <ProgressBar variant="success" now={x}  label={<span style={{color:'#222222'}}>&nbsp;{v}&nbsp;</span>}/>
                }
            },
            {
                dataField: 'average',
                text: Translation.get(12692 , 'Average Score %'),
                headerStyle: (colum, colIndex) => {
                    return { width:'40%' };
                },
                formatter:(cell)=>{
                    var v =  Number((Math.ceil(cell ))).toFixed(0) + '%'
                    var x = Number((Math.ceil(cell ))).toFixed(0);
                    return <ProgressBar variant="success" now={x}  label={<span style={{color:'#222222'}}>&nbsp;{v}&nbsp;</span>}/>
                }
            },
        ];

        for(var idx = 0 ; idx < this.state.features.length; idx++){
            if(this.state.features[idx] == "custom_content") {
                continue;
            }
            if (this.state.features[idx] == "grammar" && this.state.grammarProgressTable.length == 0) {
                continue;
            }
            if (this.state.features[idx].indexOf("vocabAdditional-") > -1) {
                var dataStuff = this.state.features[idx].split("-");
                var uid = dataStuff[1];
                tabs.push(  <Tab style={{marginLeft:"10px"}} eventKey={this.state.features[idx]} title={this.additionalDataScreens[uid].name}>
                    <GeneralTable noBoarder noSearch data={this.additionalDataScreens[uid].table || []} columns={columns}/>
                </Tab>)
            } else {
                tabs.push(  <Tab style={{marginLeft:"10px"}} eventKey={this.state.features[idx]} title={this.state.keys[this.state.features[idx]].title}>
                    <GeneralTable noBoarder noSearch data={this.state[this.state.keys[this.state.features[idx]].table] || []} columns={columns}/>
                </Tab>)
            }

        }

        return tabs;
    }

    render(){
        var tabs = this.generateTabs();
        return <div><br/>
            <hr/>
            <b style={{margin:"10px"}}>{Translation.get(12670,"Students' Progress")}</b>
            <Row>
                <Col md={12}>
                <div style={{margin:"10px"}}><LanguageSelect limitLanguages={this.props.languages} returnValue={this.updateLanguage.bind(this)}/></div>
            </Col>
            </Row>
            <Tabs
                id="controlled-tab-example"
                activeKey={this.state.key}
                onSelect={key => this.setState({ key })}>
                {this.generateTabs()}
            </Tabs>
        </div>
    }
}